import { Fragment } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import { useOrganization } from '@/pages/organizations/detail'
import OrganizationSetsPage from '@/pages/organizations/detail/sets'
import { titleTagSuffix } from '@/common/constants'
import { Helmet } from '@/common/components/Helmet'
import { organizationDisplayName } from '@/common/classes/OrganizationUtils'

export const Route = createFileRoute('/app/organizations/$organizationId/sets')(
  {
    beforeLoad: ({ context }) => {
      requireAuth(context)
    },
    component: RouteComponent,
  },
)

function RouteComponent() {
  const { organization } = useOrganization()

  return (
    <Fragment>
      {organization && (
        <Helmet>
          <title>
            {organizationDisplayName(organization)} Assessments{titleTagSuffix}
          </title>
          <meta property="og:title" content={`${organizationDisplayName(organization)} Assessments`} />
        </Helmet>
      )}
      <OrganizationSetsPage />
    </Fragment>
  )
}
